// @ts-ignore
const coworkerOptionsParser = ({ results }) =>
  // @ts-ignore
  results.map(({ email, profile, id }) => {
    if (!profile) return {};
    return {
      key: id,
      fullName: `${profile?.first_name} ${profile?.last_name}`,
      email: profile?.email || email || '',
    };
  });
export default coworkerOptionsParser;
